import { combineReducers } from "redux";
import global from "./global/reducers";
import auth from "./auth/reducers";

export default combineReducers({ global, auth });
